// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'app';

export const Component = () => (
  <path d='M23.605 18.15V6.37L12.302 0 1 6.37v11.78h.048c0 .145 0 .192.047.24l.096.096.097.096 10.775 5.89c.048.048.144.048.24.048.095 0 .19 0 .238-.047l10.776-5.891.096-.096.096-.096c.048-.048.048-.096.048-.24h.048ZM22.599 6.945v10.344l-6.13-3.496c-.048-.047-.096-.047-.24-.047-.334 0-.478.143-.478.478 0 .192.096.336.239.432l6.082 3.496-9.292 5.029V12.452l9.818-5.508h.001ZM3.011 6.369l8.812-4.98v5.986c0 .335.144.479.48.479.334 0 .478-.144.478-.479V1.388l8.813 4.98-9.292 5.269-9.291-5.268Zm-1.006.575 9.818 5.508V23.18L2.53 18.15l6.082-3.495a.502.502 0 0 0 .24-.432c0-.335-.144-.478-.48-.478-.143 0-.191 0-.239.047l-6.13 3.496V6.944Z' />
);

export const viewBox = '0 0 25 25';
